import { createActions } from 'reduxsauce';

const { Types, Creators } = createActions({
  trackEvent: ['eventName', 'dataFields'],
  trackGAEvent: ['event', 'params'],
});

export const TrackingTypes = Types;
export default Creators;
